/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { OrganizationData, OrganizationSettings } from "@/types";
import type { OrgApiResponse } from "./types";

/**
 * Transform API response (snake_case) to OrganizationData (camelCase)
 */
export function transformOrganizationResponse(
  orgResponse: OrgApiResponse,
): OrganizationData {
  return {
    organization_id: orgResponse.id,
    name: orgResponse.name,
    settings: (orgResponse.settings ?? {}) as OrganizationSettings,
    created_at: orgResponse.created_at ?? "",
    updated_at: orgResponse.updated_at ?? "",
    phone: orgResponse.phone ?? undefined,
    website: orgResponse.website ?? undefined,
    taxId: orgResponse.tax_id ?? undefined,
    addressLine1: orgResponse.address_line_1 ?? undefined,
    addressLine2: orgResponse.address_line_2 ?? undefined,
    city: orgResponse.city ?? undefined,
    state: orgResponse.state ?? undefined,
    postalCode: orgResponse.postal_code ?? undefined,
    country: orgResponse.country ?? undefined,
    industry: orgResponse.industry ?? undefined,
    size: orgResponse.size ?? undefined,
  };
}
